//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poFinishProdCompsBs', {
//        templateUrl: 'views/components/views/poFinishProdCompsBs/poFinishProdCompsBs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'poFinishProdCompsBsService', function ($stateParams, poFinishProdCompsBsService) {
//            const vm = this;
//            let p2PoFinishProdCompKeyno = $stateParams.p2_pofinishprodcomp_keyno;

//            vm.model = {
//                itemsListComponents: []
//            };

//            async function loadPoFinishProdCompsBs() {
//                vm.model.itemsListComponents = await poFinishProdCompsBsService.listPoFinishProdCompsBs({ p2_pofinishprodcomp_keyno: p2PoFinishProdCompKeyno });
//            }

//            vm.$onInit = async function () {
//                loadPoFinishProdCompsBs();
//            }
//        }]
//    });
//})();
